import { DemandeIntervention } from '@/models/DemandeIntervention';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { MutationTree } from 'vuex';
import { DEMANDE_INTERVENTION } from './mutation-types';
import { initialState as resetState, SuiviDemandeInterventionState } from './state';

export const mutations: MutationTree<SuiviDemandeInterventionState> = {
    [DEMANDE_INTERVENTION.SET_ITEMS](state, items: DemandeIntervention[]) {
        state.demandesIntervention = items;
    },
    [DEMANDE_INTERVENTION.RESET_ITEMS](state) {
        state.demandesIntervention = [];
        state.page = 0;
        state.count = 0;
    },
    [DEMANDE_INTERVENTION.REMOVE_ITEM](state, id: number) {
        state.demandesIntervention = state.demandesIntervention.filter(item => item.id !== id);
        state.count = Math.max(0, state.count - 1);
    },
    [DEMANDE_INTERVENTION.ADD_ITEMS](state, items: DemandeIntervention[]) {
        state.demandesIntervention = [...state.demandesIntervention, ...items];
    },
    [DEMANDE_INTERVENTION.SET_PAGE](state, page: number) {
        state.page = page;
    },
    [DEMANDE_INTERVENTION.SET_COUNT](state, count: number) {
        state.count = count;
    },
    [DEMANDE_INTERVENTION.SET_NB_OF_PAGES](state, pages: number) {
        state.nbOfPages = pages;
    },

    [DEMANDE_INTERVENTION.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },
    [DEMANDE_INTERVENTION.SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        const tableHeader = state.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return [...newTable, headerItem];
        }, [] as TableHeader[]);
        state.tableHeader = tableHeader;
        state.sort = sort;
    },
    [DEMANDE_INTERVENTION.ADD_FILTER_SITE](state, site: number) {
        state.filterSite = [...state.filterSite, site];
    },
    [DEMANDE_INTERVENTION.REMOVE_FILTER_SITE](state, site: number) {
        state.filterSite = state.filterSite.filter(x => x !== site);
    },
    [DEMANDE_INTERVENTION.SET_FILTER_SITE](state, siteList: Array<number>) {
        state.filterSite = siteList;
    },
    [DEMANDE_INTERVENTION.SET_FILTER_SITE_IDS](state, siteList: Array<number>) {
        state.siteIds = siteList;
    },
    [DEMANDE_INTERVENTION.ADD_FILTER_STATUS](state, status: string) {
        state.filterStatus = [...state.filterStatus, status];
    },
    [DEMANDE_INTERVENTION.REMOVE_FILTER_STATUS](state, status: string) {
        state.filterStatus = state.filterStatus.filter(x => x !== status);
    },
    [DEMANDE_INTERVENTION.SET_FILTER_STATUS](state, statusList: Array<string>) {
        state.filterStatus = statusList;
    },
    [DEMANDE_INTERVENTION.SET_FILTER_DEMANDE_INTERVENTION_ID](state, id: string) {
        state.filterDemandeInterventionId = id;
    },
    [DEMANDE_INTERVENTION.SET_FILTER_ONLY_MINE](state, onlyMine: boolean) {
        state.filterMine = onlyMine;
    },
    [DEMANDE_INTERVENTION.SET_FILTER_CREATED_DATE_FROM](state, value: string) {
        state.filterCreatedDateFrom = value;
    },
    [DEMANDE_INTERVENTION.SET_FILTER_CREATED_DATE_TO](state, value: string) {
        state.filterCreatedDateTo = value;
    },
    [DEMANDE_INTERVENTION.SET_IS_LOADING](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [DEMANDE_INTERVENTION.SET_ERROR](state, error: Error) {
        state.error = error;
    },
    [DEMANDE_INTERVENTION.CLEAR_ALL](state) {
        Object.assign(state, resetState);
    },
    [DEMANDE_INTERVENTION.SET_ATTACHMENT](state, attachment: any) {
        state.attachment = attachment;
    },
    [DEMANDE_INTERVENTION.SET_ATTACHMENT_TYPE](state, type: string) {
        state.attachmentType = type;
    },
    [DEMANDE_INTERVENTION.SET_ATTACHMENT_LOADING](state, loading: boolean) {
        state.isAttachmentLoading = loading;
    },

    [DEMANDE_INTERVENTION.SET_EXPORT_XLS_IS_LOADING](state, isLoading: boolean) {
        state.isExportXlsLoading = isLoading;
    },

};
